<template>
  <div id="app">
    <router-view name="header" />
    <div class="wrapper" :class="{ 'employee-profile-wrapper': $route.name === 'EmployeeProfile' }">
      <router-view />
    </div>
    <router-view name="footer" />
  </div>
</template>
<script>
export default {};
</script>

<style>
.wrapper.employee-profile-wrapper {
  margin-top: 0;
}
</style>
